export default {
	globalError: 'Произошла ошибка',
	invalidUsername_GENERATE: 'Имя аккаунта занято',
	invalidUsername_RESOURCE: 'Аккаунт не найден',
	notEnoughBalance_RESOURCE: 'В данный момент не можем выполнить операцию, так как баланс нашего сервиса зарезервирован под другие операции. Мы знаем об этом и уже его пополняем - это займет некоторое время. Попробуйте позже или укажите меньший объем ресурсов',
	notEnoughBalance_GENERATE: 'В данный момент не можем выполнить операцию, так как баланс нашего сервиса зарезервирован под другие операции. Мы знаем об этом и уже его пополняем - это займет некоторое время. Попробуйте позже',
}
